import { render, staticRenderFns } from "./AddIllegal.vue?vue&type=template&id=50f55169&scoped=true&"
import script from "./AddIllegal.vue?vue&type=script&lang=ts&"
export * from "./AddIllegal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f55169",
  null
  
)

export default component.exports